export class GisDataModel {
  cityId?: string;
  city?: string;
  zipCode?: string;
  street?: string;
  streetId?: string;
  houseNo?: string;
  houseNoAddition?: string;
  sapDistrictNumber?: string;
  district?: string;
  longitude?: string;
  latitude?: string;
  // Aux Fields for GisData Component
  id?: string;
  availableAreas?: any;
  isNewDevelopmentArea?: boolean;
  developmentAreaName?: string;
  corridorNumber?: string;
  zipCodeCity?: string;
  orgEinheit?: string;
  // Unique identifier ConnectionObject
  uniqueCoId?: string;
  originalData?: any;
  gridConnectionPoints?: {
    area: string;
    value: string;
  }[];
}

export enum GisFieldsEnum {
  zipCode = 'zipCode',
  street = 'street',
  streetNo = 'streetNo',
  developmentArea = 'developmentArea'
}
